import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/PreciosStockDetalladoPage.css';

const ProductosAsociados = ({ productosAsociados }) => {
    const navigate = useNavigate();
    const [indiceSeleccionado, setIndiceSeleccionado] = React.useState(0);
    const [indiceAsociacionSeleccionada, setIndiceAsociacionSeleccionada] = React.useState(0);

    React.useEffect(() => {
        if (productosAsociados?.length > 0) {
            setIndiceSeleccionado(0);
            setIndiceAsociacionSeleccionada(0);
        }
    }, [productosAsociados]);

    const handleCardClick = (index, asociacionIndex) => {
        if (!productosAsociados?.[asociacionIndex]?.ProductosPorValor?.[index]) return;

        setIndiceAsociacionSeleccionada(asociacionIndex);
        setIndiceSeleccionado(index);

        const item = productosAsociados[asociacionIndex].ProductosPorValor[index];
        const codigoANavegar = item.Codigo ||
            (item.InventarValor ? item.InventarValor.toLowerCase().replace(/\s+/g, '-') : '');
        if (codigoANavegar) {
            navigate(`/precios_stock_detallado/${codigoANavegar}`);
        }
    };

    return (
        <>
            {productosAsociados?.map((asociacion, asociacionIndex) => (
                <div key={asociacionIndex} style={{ width: '100%' }}>
                    <>
                        <hr
                            style={{
                                marginTop: '15px',
                                marginBottom: '18px',
                                height: '2px',
                                borderTopColor: '1px solid #eee'
                            }}
                        />
                        <p
                            style={{
                                textAlign: 'center',
                                fontWeight: 400,
                                fontSize: '12px',
                                lineHeight: '16px',
                                letterSpacing: '0px',
                            }}
                        >
                            {asociacion.ClaveProductos}:
                            <span
                                style={{
                                    fontWeight: 600,
                                    fontSize: '12px',
                                    lineHeight: '16px',
                                    letterSpacing: '0px',
                                }}
                            >
                                {' '}
                                {asociacion.ProductosPorValor?.[
                                    indiceAsociacionSeleccionada === asociacionIndex
                                        ? indiceSeleccionado
                                        : 0
                                ]?.InventarValor || ''}
                            </span>
                        </p>
                    </>

                    <div className="productos-por-valor-grid">
                        {asociacion.ProductosPorValor?.map((item, index) => (
                            <div
                                key={index}
                                className={`producto-card ${indiceAsociacionSeleccionada === asociacionIndex &&
                                    indiceSeleccionado === index ? 'selected' : ''
                                    }`}
                                onClick={() => handleCardClick(index, asociacionIndex)}
                            >
                                <div className="producto-card-img-container">
                                    <img
                                        src={`${item.Imagen}?width=150&quality=70`}
                                        srcSet={`
                                                    ${item.Imagen}?width=75&quality=50 75w,
                                                    ${item.Imagen}?width=150&quality=70 150w
                                                `}
                                        sizes="(max-width: 600px) 75px, 150px"
                                        className="producto-card-img"
                                        loading="lazy"
                                        alt={item.InventarValor || "Producto asociado"}
                                        decoding="async"
                                        onError={(e) => {
                                            e.target.src = '/assets/placeholder-thumbnail.webp';
                                            e.target.srcset = '';
                                        }}
                                    />
                                </div>
                                <div className="producto-card-info">
                                    <p className="producto-card-valor" title={item.InventarValor}>
                                        {item.InventarValor}
                                    </p>
                                    <p className="producto-card-precio">
                                        Q.{item.PrecioNormal?.toFixed(2)}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </>
    );
};

export default ProductosAsociados;